import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: {},
  token: null,
  isAuthenticated: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authLogin: (state, action) => {
      const data = action.payload;
      state.userData = { ...state.userData, ...data };
      state.token = data.accessToken;
      state.isAuthenticated = true;
    },
    logout: () => {
      sessionStorage.clear();
      localStorage.clear();
      return initialState;
    }
  }
});

export const { authLogin, logout } = authSlice.actions;
export const authSelector = state => state.auth;

export default authSlice.reducer;
